import '../CSS/Estilo.css';

export default function FormularioBusqueda({config,rotuloForm,onClick})
{
    return(
        <div>
            <label style={{color:config.estiloPagina.color,width:'100%',display:'block',textAlign:'center',
                marginBottom:'2%'}} className='rotuloMediano'>{rotuloForm}</label>
            <div id={"simple"}>
                    <label style={{color:config.estiloPagina.color}} className={"lbForm"}>Uid</label>
                    <input className={"tbForm"} autoFocus type="text" id="uid" name="uid" />
                <button style={{marginLeft:'46.3%'}}className='btEnvio' onClick={onClick} >Enviar</button>
            </div>
        </div>
    )
}